import {DateRange} from './date-range';
import {FullLengthDateRange} from './full-length-date-range';
import {FullLengthDateRangeHourMinute} from './full-length-date-range-hour-minute';
import {ImpactDateRange} from './impact-date-range';
import {InsightsTimePickerDateRange} from './insights-time-picker-date-range';
import {PropertyFilterDateRange} from './property-filter-date-range';
import {PropertyFilterDateRangeHourMinute} from './property-filter-date-range-hour-minute';
import {RelativeDateRange} from './relative-date-range';
import {DisplayContext} from './types';

export const DATE_RANGE_TYPES: {[key in DisplayContext]: typeof DateRange} = {
  [DisplayContext.RelativeRange]: RelativeDateRange,
  [DisplayContext.Default]: DateRange,
  [DisplayContext.FullLength]: FullLengthDateRange,
  [DisplayContext.FullLengthHourMinute]: FullLengthDateRangeHourMinute,
  [DisplayContext.ImpactTimePicker]: ImpactDateRange,
  [DisplayContext.InsightsTimePicker]: InsightsTimePickerDateRange,
  [DisplayContext.PropertyFilter]: PropertyFilterDateRange,
  [DisplayContext.PropertyFilterHourMinute]: PropertyFilterDateRangeHourMinute,
};

export class DateRangeFactory {
  public static createDateRange(
    attributes: Partial<DateRange>,
    {displayContext}: {displayContext: DisplayContext},
  ): DateRange {
    // TODO(go/j/AE-315): Cleanup once minute time picker launches.
    // This is to enable hiding hour/minute selection behind a feature-flag
    if (displayContext === DisplayContext.FullLength) {
      displayContext = DisplayContext.FullLengthHourMinute;
    } else if (displayContext === DisplayContext.PropertyFilter) {
      displayContext = DisplayContext.PropertyFilterHourMinute;
    }
    const DateRangeClass = DATE_RANGE_TYPES[displayContext];
    return new DateRangeClass(attributes);
  }
}
